import React, { useMemo } from 'react'
import { Combobox } from '@enamelai/design-system'
import { CHART_NAME_OPTIONS } from '@constants/Charting/chartNameOptions'

const PRESET_OPTIONS = CHART_NAME_OPTIONS.map((name) => ({
  value: name,
  label: name,
}))

type ChartNameComboBoxProps = {
  value: string
  onChange: (title: string) => void
  readOnly: boolean
  disabled?: boolean
  isInvalid?: boolean
  helperText?: string
  label?: string
}

const ChartNameComboBox = ({
  value,
  onChange,
  readOnly,
  disabled = false,
  isInvalid = false,
  helperText,
  label = 'Chart name',
}: ChartNameComboBoxProps): React.ReactElement => {
  const options = useMemo(() => {
    const trimmed = value.trim()
    if (trimmed && !PRESET_OPTIONS.some((option) => option.value === trimmed)) {
      return [...PRESET_OPTIONS, { value: trimmed, label: trimmed }]
    }
    return PRESET_OPTIONS
  }, [value])

  return (
    <Combobox
      label={label}
      placeholder="Chart name"
      options={options}
      value={value}
      allowCustom={!readOnly}
      filterable={!readOnly}
      disabled={disabled || readOnly}
      error={isInvalid}
      helperText={helperText}
      onChange={(nextTitle): void => {
        if (readOnly || nextTitle === value) {
          return
        }
        onChange(nextTitle)
      }}
    />
  )
}

export default ChartNameComboBox
